export enum LicenseModules {
  /** Moduł oceny ryzyka */
  Evaluation = 'evaluation',
  /** Moduł "Niezgodności" */
  NonConformities = 'discrepancies',
}
